module.exports = __webpack_public_path__ + "static/media/plate_bhaat1.d8a705be.png";